<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white cursor-pointer"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
        @click="iconPickerVisible = true"
      >
        <icon v-if="this.module.settings.icon" :name="this.module.settings.icon" class="text-white" />
      </div>
      <h3 class="text-2xl font-medium ml-4">Print Order</h3>
    </div>

    <label class="block mb-2 text-xs">Title</label>
    <input type="text" placeholder="Title" class="input-sm w-full mb-4" v-model="module.title" required>
    <label class="block mb-2 text-xs">Description</label>
    <textarea rows="3" class="input-sm w-full mb-4" placeholder="Description" v-model="module.settings.description" required></textarea>
    <loader v-if="!loaded" />
    <div v-else>
      <label class="block mb-2 text-xs">Product Category</label>
      <select v-model="module.settings.category" id="category" name="category" class="w-full border mb-4 px-2 py-2 text-sm bg-grey-lightest" required>
        <option :value="null">Select product...</option>
        <option v-for="(category, i) in products" :key="i" :value="category.id">{{ category.name }}</option>
      </select>
      <label class="block mb-2 text-xs">Product</label>
      <select v-model="module.settings.product" id="product" name="product" :disabled="module.settings.category === null" class="w-full border mb-4 px-2 py-2 text-sm bg-grey-lightest" required>
        <option :value="null">Select item</option>
        <option v-for="(product, i) in categoryProducts" :key="i" :value="product.id">{{ product.name }}</option>
      </select>
    </div>
    <label class="block mb-2 text-xs">Call To Action</label>
    <input type="text" placeholder="Order Now" class="input-sm w-full mb-4" v-model="module.settings.action" required>

    <modal v-if="iconPickerVisible" :scrollY="false">
      <icon-picker />
    </modal>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'
import { EventBus } from '@/EventBus'
import IconPicker from '@/components/IconPicker'

export default {
  components: { IconPicker },

  props: ['module'],

  data () {
    return {
      officeAccess: true,
      products: [],
      categoryId: null,
      productId: null,
      loaded: false,
      iconPickerVisible: false
    }
  },

  computed: {
    ...mapState(['selectedOffice']),
    categoryProducts () {
      let category = this.products.filter(c => c.id === this.module.settings.category)
      if (category.length === 1) {
        return category[0].items
      }
    }
  },

  methods: {
    loadProducts () {
      return v2Api.get('custom-print-order-items/products', {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.products = response.data.products
      }).catch(() => {
        this.officeAccess = false
        this.loaded = true
      })
    },
    saved (data) {
      if (this.iconPickerVisible) {
        this.iconPickerVisible = false
        this.$set(this.module.settings, 'icon', data.icon)
        this.$set(this.module.settings, 'icon_color', data.color)
      }
    },

    cancelled () {
      this.iconPickerVisible = false
    }
  },

  created () {
    EventBus.$on('icon-picker:cancel', this.cancelled)
    EventBus.$on('icon-picker:saved', this.saved)

    this.loadProducts().then(() => {
      this.loaded = true
    })
  },

  beforeDestroy () {
    EventBus.$off('icon-picker:cancel', this.cancelled)
    EventBus.$off('icon-picker:saved', this.saved)
  }
}
</script>
